var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { convertSiteLevelMetaTags } from '../../converters/convert-site-level-meta-tags';
import { getUserPatternByItemType } from '../../patterns/get-user-pattern-by-item-type';
import { getContext } from '../../tags/context/get-context';
import { STATIC_PAGE_V2 } from '../../types/ItemTypes';
import { filterPageLevelTags } from '../../tags/filters/filter-page-level-tags';
import { getAdapter } from '../../adapters';
import { convertSeoModel } from '../../converters/convert-seo-model';
import { getPatternBlob } from '../../patterns';
import { resolveWithPatterns } from '../resolve-with-patterns';
import { getDefaultItemPayload } from '../../patterns/get-default-item';
import { handleOldBlog } from '../../item-types/blog-post/handleOldBlogPost/handle-old-blog-post';
import { CONTEXT_PROPS } from '../../types/ContextProps';
import { filterPayloadWithoutVelo } from '../../tags/filters/filter-payload-without-velo';
function _getEditorPayload(context, pageLevelSeoData) {
    var editorPanelLegacyData = getAdapter(STATIC_PAGE_V2).getLegacySeoBlob({
        context: context,
    });
    var editorPanelPageData = convertSeoModel(pageLevelSeoData.advancedSeoData);
    return [editorPanelLegacyData, editorPanelPageData];
}
function _getDefaultPatternsSchemas(siteLevelSeoData, itemType) {
    var defaultStaticPatternSchema = getPatternBlob(STATIC_PAGE_V2);
    var defaultItemTypePatternSchema = getPatternBlob(itemType);
    return [defaultStaticPatternSchema, defaultItemTypePatternSchema];
}
export function getTags(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.siteLevelSeoData, siteLevelSeoData = _c === void 0 ? {} : _c, _d = _b.pageLevelSeoData, pageLevelSeoData = _d === void 0 ? {} : _d, _e = _b.veloOverrides, veloOverrides = _e === void 0 ? [] : _e, _f = _b.veloItemPayload, veloItemPayload = _f === void 0 ? getDefaultItemPayload() : _f, _g = _b.dynamicPageData, dynamicPageData = _g === void 0 ? [] : _g, _h = _b.tpaSeoEndpointData, tpaSeoEndpointData = _h === void 0 ? [] : _h, _j = _b.tpaOverrides, tpaOverrides = _j === void 0 ? [] : _j;
    var siteLevelMetaTags = filterPageLevelTags(convertSiteLevelMetaTags(siteLevelSeoData.metaTags));
    var itemType = veloItemPayload.itemType, itemData = veloItemPayload.itemData, seoData = veloItemPayload.seoData, asNewPage = veloItemPayload.asNewPage;
    var userPatternSchema = getUserPatternByItemType(siteLevelSeoData.userPatterns, itemType);
    var patternSchemas = __spreadArrays(_getDefaultPatternsSchemas(siteLevelSeoData, itemType), [
        userPatternSchema,
    ]);
    var context = getContext(siteLevelSeoData, pageLevelSeoData, userPatternSchema);
    var adapter = getAdapter(itemType);
    var platformLegacySeoOverrides = adapter.getLegacySeoBlob(itemData);
    var platformSchemaOverrides = seoData;
    var platformPayload = context[CONTEXT_PROPS.CURR_LANG_IS_ORIGINAL]
        ? [platformLegacySeoOverrides, platformSchemaOverrides]
        : [platformSchemaOverrides, platformLegacySeoOverrides];
    var contextWithItemData = __assign(__assign({}, itemData), { context: context });
    var payload;
    if (asNewPage) {
        payload = __spreadArrays([siteLevelMetaTags], patternSchemas, platformPayload);
    }
    else {
        payload = __spreadArrays([
            siteLevelMetaTags
        ], patternSchemas, _getEditorPayload(context, pageLevelSeoData), [
            dynamicPageData,
            tpaSeoEndpointData,
            tpaOverrides
        ], platformPayload);
        payload = [filterPayloadWithoutVelo(payload, veloOverrides), veloOverrides];
    }
    var adaptedContext = adapter.getData(contextWithItemData);
    var resolvedTags = resolveWithPatterns(payload, adaptedContext);
    return handleOldBlog(resolvedTags, siteLevelSeoData);
}
